export const dashboardConstants = {
    ANALYTICS_REQUEST: 'DASHBOARD_ANALYTICS_REQUEST',
    ANALYTICS_SUCCESS: 'DASHBOARD_ANALYTICS_SUCCESS',
    ANALYTICS_FAILURE: 'DASHBOARD_ANALYTICS_FAILURE',
};
